import { i as h, s as p, x as c } from "../../lit-element-6iugfgmM.js";
import { e as m } from "../../custom-element-wk-AooBb.js";
import { n as l } from "../../property-BWlAHqg_.js";
import "../../query-assigned-elements-B8U94KLQ.js";
const v = h`:host{--flyout-transition-time: .2s;--spectrum-tabs-item-gap: 0;bottom:0;left:0;position:fixed;top:0;transform:translate(-100%);transition:transform var(--flyout-transition-time);z-index:3}:host([right]){transform:translate(100%)}:host([top]){transform:translateY(-100%)}:host([bottom]){transform:translateY(100%)}:host([expanded]){transform:translate(0)}:host([expanded][bottom]),:host([expanded][right]),:host([expanded][top]){transform:translate(0)}:host([overlay]):before{background-color:var(--spectrum-global-color-static-black);content:\"\";display:none;height:200vh;opacity:0;position:fixed;top:0;width:200vw;z-index:-1}:host([bottom]):before,:host([right]):before,:host([top]):before{left:-100vw}:host([bottom]):before{top:-100vh}:host([overlay][expanded]):before{display:block;opacity:.35}`;
var u = Object.defineProperty, f = Object.getOwnPropertyDescriptor, d = (t, s, i, a) => {
  for (var r, e = a > 1 ? void 0 : a ? f(s, i) : s, n = t.length - 1; n >= 0; n--) (r = t[n]) && (e = (a ? r(s, i, e) : r(e)) || e);
  return a && e && u(s, i, e), e;
};
let o = class extends p {
  constructor() {
    super(...arguments), this.expanded = !1, this.overlay = !1, this._handleClick = (t) => {
      t.stopPropagation();
    }, this._handleOutsideSlotClick = (t) => {
      t.stopPropagation(), this.removeAttribute("expanded");
    }, this._updateAutocloseEvents = () => {
      this.expanded ? (this.addEventListener("click", this._handleOutsideSlotClick), window.addEventListener("click", this._handleOutsideSlotClick)) : this._removeEventListeners();
    };
  }
  static get styles() {
    return v;
  }
  async updated(t) {
    if (this._dispatchUpdateEvent(), t.has("expanded")) return this.hasAttribute("autoclose") ? new Promise(requestAnimationFrame).then(() => {
      this._updateAutocloseEvents();
    }) : Promise.resolve();
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this._removeEventListeners();
  }
  render() {
    return c`<slot @click="${this._handleClick}"></slot>`;
  }
  _dispatchUpdateEvent() {
    this.dispatchEvent(new CustomEvent(this.expanded ? "expand" : "collapse"));
  }
  _removeEventListeners() {
    this.removeEventListener("click", this._handleOutsideSlotClick), window.removeEventListener("click", this._handleOutsideSlotClick);
  }
};
d([l({ type: Boolean })], o.prototype, "expanded", 2), d([l({ type: Boolean })], o.prototype, "overlay", 2), o = d([m("af-flyout")], o);
const _ = o;
export {
  _ as default
};
//# sourceMappingURL=Flyout.js.map
